import React, {Component, PropTypes} from "react";
import {inject, observer} from 'mobx-react';
import {Button, Spin} from "antd";
import {WeaScroll, WeaDialog, WeaPopoverHrm, WeaNewScrollPagination,WeaShare } from 'ecCom'
import SearchFavourite from "../../util/SearchFavourite";


import SysFavouriteBar from "./SysFavouriteBar";
import SysFavouriteList from "./SysFavouriteList";
import EditSysFavourite from "./EditSysFavourite";
import FavouriteBrowser from "./FavouriteBrowser";

@inject("favouriteDialogStore")
@inject("favouriteBrowserStore")
@inject("sysFavouriteStore")
@inject("favouriteDirStore")
@inject("myFavouriteStore")
@inject("sysFavFormStore")

@observer
export default class SysFavourite extends Component {
    constructor(props) {
        super(props);
        this.state = {favListHeight: 0};
    }

    /**
     * 滚动加载收藏夹的内容
     */
    handleScroll = () => {
        let {sysFavouriteStore} = this.props;
        let offset = jQuery(".sysfav-item-loadding").position();
        let winHeight = jQuery(document.body).height();
        let {top} = offset;

        let conditions = SearchFavourite.getConditions();
        let {iscomplete, current, total} = conditions;

        if (top <= winHeight && iscomplete) {   //说明最下方的div可见，加载下一页的数据
            let searchFavourite = new SearchFavourite(sysFavouriteStore);
            let isinit = false;
            let isreload = false;
            let params = {isinit, isreload};
            searchFavourite.loadPage(params);
        }
    }

    fetchData = () => {
        let {sysFavouriteStore,} = this.props;
        let conditions = SearchFavourite.getConditions();
        let {iscomplete, current, total} = conditions;
        if (iscomplete) {   //加载下一页的数据
            let searchFavourite = new SearchFavourite(sysFavouriteStore);
            let isinit = false;
            let isreload = false;
            let params = {isinit, isreload};
            searchFavourite.loadPage(params);
        }
    }


    /**
     * 设置加载的提示信息
     */
    setLoaddingMsg = () => {
        let {myFavouriteStore, sysFavouriteStore} = this.props;
        let {loadingmsg, nodata, nomoredata} = myFavouriteStore;
        let {spinning} = sysFavouriteStore;
        let {total, current, iscomplete} = SearchFavourite.getConditions();
        let conditions = SearchFavourite.getConditions();
        if (!spinning) {    //没有显示遮罩时，才显示这个div的提示信息
            if (iscomplete) {
                if (current == total) {
                    jQuery(".sysfav-item-loadding").html(nomoredata);
                }
                if (total <= 0) {
                    jQuery(".sysfav-item-loadding").html(nodata);
                }
                if (current < total) {
                    jQuery(".sysfav-item-loadding").html(loadingmsg);
                }
            } else {
                jQuery(".sysfav-item-loadding").html(loadingmsg);
            }
        } else {
            jQuery(".sysfav-item-loadding").html("");
        }
    }

    componentDidUpdate() {
        this.setLoaddingMsg();
        if(this.props.changename=='fullPagetreeRight'){
            jQuery(".fullPagetreeRight .ant-spin-container").css({"height": "100%"});
        }else{
            jQuery(".sysfav-main .ant-spin-container").css({"height": "100%"});
        }
              
        let oheight = this.state.favListHeight;
        let favListHeight = jQuery(".sysfav-main-list").height();
        if (oheight != favListHeight) {
            this.setState({favListHeight});
        }
    }

    componentDidMount() {
        let favListHeight = jQuery(".sysfav-main-list").height();
        this.setState({favListHeight});
    }

    render() {
        let {
            favouriteDialogStore,
            favouriteBrowserStore,
            sysFavouriteStore,
            favouriteDirStore,
            myFavouriteStore,
            sysFavFormStore
        } = this.props;

        let stores = {
            favouriteDialogStore,
            favouriteBrowserStore,
            sysFavouriteStore,
            favouriteDirStore,
            myFavouriteStore,
            sysFavFormStore
        };

        let {
            addBtnName, addBtnList, typeList,
            moveBtnName, deleteBtnName, repeatIconTitle,
            editIconTitle, moveIconTitle, deleteIconTitle,
            favTypeMap, loadingmsg, nodata, nomoredata
        } = myFavouriteStore;

        let {data, favtype, selectedIds, moveids, spinning, tip} = sysFavouriteStore;

        let {showEditDialog, showBrowserDialog} = favouriteDialogStore;

        let bar = {
            addBtnName, addBtnList, typeList,
            moveBtnName, deleteBtnName, selectedIds, favtype
        };

        let list = {data, favtype, selectedIds, moveids, spinning, tip, favTypeMap, loadingmsg, nodata, nomoredata};
        let btns = {repeatIconTitle, editIconTitle, moveIconTitle, deleteIconTitle};
        let dialog = {showEditDialog, showBrowserDialog};

        let props1 = {...bar, ...stores};
        let props2 = {...list, ...stores, ...btns};

        let {favListHeight} = this.state;
        return (
            <div className={this.props.changename=='fullPagetreeRight'?'fullPagetreeRight':'sysfav-main'}>
                <Spin spinning={spinning} tip={tip} size="large" style={{"height": "100%"}}>
                    <SysFavouriteBar {...props1}/>
                    <div className="sysfav-main-list">
                        <WeaPopoverHrm>
                            <WeaNewScrollPagination onScrollEnd={this.fetchData} height={favListHeight}>
                                <SysFavouriteList {...props2}/>
                                <div className="sysfav-item-loadding"></div>
                            </WeaNewScrollPagination>
                        </WeaPopoverHrm>

                        <EditSysFavourite {...stores}/>

                        <FavouriteBrowser {...stores}/>
                        <WeaShare
                        visible={sysFavouriteStore.shareShow}
                        onVisibleChange={bool =>{this.props.sysFavouriteStore.shareShow=bool}}
                        shareParams={{
                            resourcetype: 152,
                            resourceid:sysFavouriteStore.sharedata.favid
                        }}
                        msginfo={[
                            {
                                "sharetitle": sysFavouriteStore.sharedata.favname,
                                "linkurl": sysFavouriteStore.sharedata.url,
                                "objectName": "FW:CustomShareMsg",
                                "canforward": 1,
                                "sharetype": "workflow",
                                "shareid": sysFavouriteStore.sharedata.favid,
                                "opentype": 1,
                                "opentype_pc": 2,
                            }
                        ]}
                    />
                    </div>
                </Spin>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/favourite/components/favourite/index.js